import { makeAutoObservable } from 'mobx'

export class ResultsKeyboardNavigationStore {
  private _highlightedIndex: number | null = null
  private _isNavigating = false

  constructor() {
    makeAutoObservable(this)
  }

  moveDown = (itemCount: number) => {
    if (itemCount === 0) return

    this._isNavigating = true

    if (this._highlightedIndex === null) {
      this._highlightedIndex = 0
      return
    }

    if (this._highlightedIndex < itemCount - 1) {
      this._highlightedIndex += 1
    }
  }

  moveUp = (): number => {
    if (this._highlightedIndex === null || this._highlightedIndex === 0) {
      this.reset()
      return -1
    }

    this._highlightedIndex -= 1
    return this._highlightedIndex
  }

  setHighlightedIndex = (index: number | null) => {
    this._highlightedIndex = index
  }

  reset = () => {
    this._highlightedIndex = null
    this._isNavigating = false
  }

  get highlightedIndex() {
    return this._highlightedIndex
  }

  get isNavigating() {
    return this._isNavigating
  }
}
